import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import './App.css'
import Home from './pages/Home'
import Features from './pages/Features'
import Pricing from './pages/Pricing'
import Integrations from './pages/Integrations'
import About from './pages/About'
import Contact from './pages/Contact'
import NotFound from './pages/NotFound'

function App() {
  return (
    <Router>
      <div className="App bg-gray-50 min-h-screen">
        <nav className="bg-primary text-white p-4 shadow-lg">
          <div className="container mx-auto flex gap-6 items-center">
            <Link to="/" className="text-xl font-bold hover:underline">Test Company</Link>
            <Link to="/" className="hover:underline">Home</Link>
            <Link to="/features" className="hover:underline">Features</Link>
            <Link to="/pricing" className="hover:underline">Pricing</Link>
            <Link to="/integrations" className="hover:underline">Integrations</Link>
            <Link to="/about" className="hover:underline">About</Link>
            <Link to="/contact" className="hover:underline">Contact</Link>
          </div>
        </nav>
        <main className="min-h-screen">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/integrations" element={<Integrations />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        </main>
        <footer className="bg-gray-800 text-white p-8 mt-16">
          <div className="container mx-auto text-center">
            <p>&copy; {new Date().getFullYear()} Test Company. All rights reserved.</p>
            
          </div>
        </footer>
      </div>
    </Router>
  )
}

export default App
